const namespace = {
  title: "Neighborhood Showcase",
  header: {
    title: "Search Neighborhoods",
    description:
      "Explore any neighborhood to find the location that’s right for you",
    search: {
      placeholder: "Search all neighborhoods",
      results: {
        all: "All neighborhoods",
        featured: "Featured neighborhoods",
      },
    },
  },
  noData:
    "You haven't added any neighborhoods to your list yet. Head over to the <bold><LinkToHub>Neighborhood Showcase</LinkToHub></bold> section to select them.",
} as const;

export default namespace;
